// An in-page notification banner.
//
// OS-level toasts depend on things the app cannot see or control — the
// Windows notification master switch, Focus Assist, per-app registration,
// the browser's own suppression heuristics. When any of those is off the
// browser still reports showNotification() as succeeding, so a push can be
// delivered correctly and still never appear on screen. This renders the
// alert inside the page instead, which for someone already working in the
// admin panel is the more useful place for it anyway.

const CONTAINER_ID = "garaji-toast-container";

function ensureContainer() {
  let container = document.getElementById(CONTAINER_ID);
  if (container) return container;

  container = document.createElement("div");
  container.id = CONTAINER_ID;
  Object.assign(container.style, {
    position: "fixed",
    top: "16px",
    right: "16px",
    zIndex: "99999",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "360px",
    pointerEvents: "none",
  });
  document.body.appendChild(container);
  return container;
}

/**
 * Shows a dismissable banner. Returns the element so callers (and tests)
 * can assert on it.
 */
export function showInAppToast({ title, body, timeout = 10000 }) {
  const container = ensureContainer();

  const toast = document.createElement("div");
  toast.className = "garaji-toast";
  Object.assign(toast.style, {
    pointerEvents: "auto",
    cursor: "pointer",
    background: "#ffffff",
    borderLeft: "4px solid #f96332",
    borderRadius: "6px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.18)",
    padding: "12px 14px",
    fontFamily: "inherit",
    color: "#252422",
    transition: "opacity .25s ease, transform .25s ease",
    opacity: "0",
    transform: "translateX(12px)",
  });

  const titleEl = document.createElement("div");
  titleEl.textContent = title;
  Object.assign(titleEl.style, {
    fontWeight: "600",
    fontSize: "14px",
    marginBottom: body ? "3px" : "0",
  });
  toast.appendChild(titleEl);

  if (body) {
    const bodyEl = document.createElement("div");
    bodyEl.textContent = body;
    Object.assign(bodyEl.style, { fontSize: "13px", opacity: "0.75" });
    toast.appendChild(bodyEl);
  }

  const remove = () => {
    toast.style.opacity = "0";
    toast.style.transform = "translateX(12px)";
    setTimeout(() => toast.parentNode && toast.parentNode.removeChild(toast), 250);
  };
  toast.addEventListener("click", remove);

  container.appendChild(toast);
  // next frame, so the transition actually runs
  requestAnimationFrame(() => {
    toast.style.opacity = "1";
    toast.style.transform = "translateX(0)";
  });

  if (timeout > 0) setTimeout(remove, timeout);
  return toast;
}
